import React, {
  useEffect,
  useMemo,
  useCallback,
  useState,
  useRef,
} from "react";
import {
  Col,
  Row,
  Modal,
  Form,
  OverlayTrigger,
  Tooltip,
  Button,
  ButtonGroup,
} from "react-bootstrap";
import { Btn } from "../../../../shared/Btn";
import Switch from "react-switch";
import Split from "react-split";
import {
  EditableFieldAmount,
  EditableFieldDateYYYYMMDD,
  EditableFieldText,
} from "../../../../utils/EditableField";
// import NewTransactionTable from "./NewTransactionTable";
import { datefilterParamsYYYYMMDD } from "../../Analyze/AnalyzeTransactionsTable";
import { DateRangeFloatingFilter } from "src/views/Docuclipper/AgGrid/DateRangeFloatingFilter";
import { AmountRangeFloatingFilter } from "src/views/Docuclipper/AgGrid/AmountRangeFloatingFilter";

import { useDispatch, useSelector } from "react-redux";
import { ReduxState } from "../../../../redux";
import {
  fetchMfs,
  fetchTls,
  setSelectedChunk,
  setSelectedFieldNames,
  setSelectedTransactionStatus,
  setTls,
  toggleLoading,
  setRefreshKey,
  setAccountChunks,
  setSelectedDocumentId,
  setSelectedAccount,
  setGridApi,
} from "../../../../redux/reducers/TransactionManager";
import { fetchTotals } from "../../../../redux/reducers/Reconciler";
import {
  createCorrection,
  createCorrectionTagLevel,
  performBulkEdit,
  performBulkEditTagLevel,
} from "../../../../docuclipper/api";
import { createAlert } from "../../../../redux/reducers/Alerts";
import { isArray } from "lodash";
import SummaryTableAccountViewHorizontal2 from "./SummaryTableAccountViewHorizontal2";
import { getDocumentName } from "../../Analyze/AnalyzeTransactionsTable/utils";
import ExternalFilter from "src/views/Docuclipper/ExternalFilter";
import {
  setExternalFiltersColumnDefs,
  clearExternalFilters,
} from "src/redux/reducers/ExternalFilter";
import PDFViewer from "../../PdfViewer";
import useBankStatementPDF from "./useBankStatementPDF";
import { isNullOrUndefined, useHasQbo } from "src/utils/utils";
import { GridReadyEvent } from "ag-grid-community";
import { IDatasource } from "ag-grid-community";
import ColumnSelector from "./ColumnSelector";
import {
  setColumnWidth,
  setColumns,
} from "../../../../redux/reducers/AgGridColumnConfig";
import PayeeCleanerConfig from "./PayeeCleanerConfig";
import { AddTransactionModal } from "./AddTransaction";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SelectAccount2 from "./ReassignAccount/SelectAccount2";
import AgBulkTable from "../../Analyze/AnalyzeTransactionsTable/AgBulkTable";
import { TableFilterConfig } from "src/docuclipper/DocuclipperTypes";
import { useLocation, useHistory } from "react-router-dom";
import { DownloadModal } from "./DownloadModal";
import { convertFilterModel, convertSortModel } from "src/utils/filters";
import AddDocumentsPopover from "./AddBankStatementsPdfCsvPopover";
import TransactionManagerTourAndReportIssue from "./TransactionManagerTour";
import HelpDrawer from "src/views/Docuclipper/Ratings/HelpDrawer";
import { useIsAdmin } from "src/utils/auth";
import { useChunkData } from "../../Analyze/AnalyzeTransactionsTable/hooks";
import PresignedDocumentViewer from "../../PdfViewer/PresignedDocumentViewer";

// Fields exposed by the "Bulk edit" modal. `col` is the correction column
// index the backend `updateField` op expects; `operation` overrides the
// default "updateField" (Category uses "updateCategory", which is not covered
// by the existing Assign-to-Account button).
type BulkEditFieldType = "text" | "date" | "number";
type BulkEditFieldDef = {
  key: string;
  label: string;
  type: BulkEditFieldType;
  col?: number;
  operation?: string;
};
const BULK_EDIT_FIELDS: BulkEditFieldDef[] = [
  { key: "payee", label: "Payee", type: "text", col: 9 },
  { key: "description", label: "Description", type: "text", col: 1 },
  { key: "checkNumber", label: "Check #", type: "text", col: 3 },
  { key: "refNumber", label: "Ref #", type: "text", col: 6 },
  { key: "date", label: "Date", type: "date", col: 0 },
  { key: "date2", label: "Date 2", type: "date", col: 5 },
  { key: "amount", label: "Amount", type: "number", col: 2 },
  { key: "balance", label: "Balance", type: "number", col: 4 },
  {
    key: "category",
    label: "Category",
    type: "text",
    operation: "updateCategory",
  },
];

// Mirrors the inline-editor validation rules (EditableFieldDateYYYYMMDD /
// EditableFieldAmount in src/utils/EditableField.tsx) so the modal enforces the
// same constraints without embedding the click-to-edit popover widgets.
const validateBulkEditValue = (
  type: BulkEditFieldType,
  value: string
): string | null => {
  if (type === "date") {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return "Enter a valid date (YYYY-MM-DD)";
    }
    const d = new Date(value);
    if (isNaN(d.getTime()) || !d.toISOString().startsWith(value)) {
      return "Enter a valid date (YYYY-MM-DD)";
    }
    return null;
  }
  if (type === "number") {
    const n = parseFloat(value);
    if (value.trim() === "" || !isFinite(n)) {
      return "Enter a valid number";
    }
    return null;
  }
  // text / category
  if (value.trim() === "") {
    return "Enter a value";
  }
  return null;
};

type Props = { hideJobButtons: boolean };
export const NewTransactionManager: React.FC<Props> = ({ hideJobButtons }) => {
  const job = useSelector((state: ReduxState) => state.JobData.job);
  const { data: jobDocs, loading } = useSelector(
    (state: ReduxState) => state.JobDocument
  );

  const selectedDocumentId = useSelector(
    (state: ReduxState) => state.TransactionManager.selectedDocumentId
  );
  const tlsDocuments = useSelector(
    (state: ReduxState) => state.TransactionManager.tls.documents
  );
  const selectedChunk = useSelector(
    (state: ReduxState) => state.TransactionManager.selectedChunk
  );
  const selectedAccount = useSelector(
    (state: ReduxState) => state.TransactionManager.selectedAccount
  );
  const paginationPageSize = useSelector(
    (state: ReduxState) => state.TransactionManager.pagination.pageSize
  );
  const refreshKey = useSelector(
    (state: ReduxState) => state.TransactionManager.refreshKey
  );

  // const isCSV = job?.metadata?.includes("csv2QboMapping");
  // console.log({ jobDocs });

  const selectedDoc = (jobDocs || []).filter(
    (x) => x.documentId.toString() === (selectedDocumentId || "").toString()
  );

  // Check if the document is viewable (PDF or image)
  const isViewableDocument = (mimetype: string): boolean => {
    return mimetype.includes("pdf") || mimetype.startsWith("image/");
  };

  const isCSV =
    selectedDoc.length > 0
      ? !isViewableDocument(selectedDoc[0].mimetype)
      : false;

  // console.log({ isCSV, selectedDoc, jobDocs, selectedDocumentId });
  // const chunkData = useChunkData();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const { externalFilters } = useSelector(
    (state: ReduxState) => state.ExternalFilter
  );

  const { selectedL1: l1, selectedL2: l2 } = useSelector(
    (state: ReduxState) => state.TagLevel
  );

  // Get l1 and l2 from URL query params
  const searchParams = new URLSearchParams(location.search);
  const urlL1 = searchParams.get("l1");
  const urlL2 = searchParams.get("l2");

  const handleAddBankStatementsPDF = () => {
    if (urlL1 && urlL2) {
      history.push(
        `/extract/bankMode?l1=${encodeURIComponent(urlL1)}&l2=${encodeURIComponent(urlL2)}`
      );
    }
  };

  const handleAddBankStatementsCSV = () => {
    if (urlL1 && urlL2) {
      history.push(
        `/extract/csv2qbo?l1=${encodeURIComponent(urlL1)}&l2=${encodeURIComponent(urlL2)}`
      );
    }
  };

  const handleDocumentAction = (path: string) => {
    const queryParams =
      l1 && l2
        ? `?l1=${encodeURIComponent(l1)}&l2=${encodeURIComponent(l2)}`
        : "";
    history.push(`${path}${queryParams}`);
  };

  // Empty State Component
  const EmptyStateComponent = () => (
    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={{ minHeight: "400px" }}
    >
      <div className="text-center mb-4">
        <FontAwesomeIcon
          icon="file-alt"
          size="4x"
          className="text-muted mb-3"
        />
        <h4 className="text-muted">No Bank Statements Found</h4>
        <p className="text-muted">
          Get started by adding your bank statements or transaction files
        </p>
      </div>

      <div className="d-flex">
        <Btn
          variant="primary"
          size="lg"
          onClick={() => handleDocumentAction("/extract/bankMode/")}
          className="d-flex flex-column align-items-center p-4"
          style={{ minWidth: "200px" }}
        >
          <FontAwesomeIcon icon="university" size="2x" className="mb-2" />
          <strong>Bank/CC Transactions</strong>
          <small className="mt-1">Upload PDF files</small>
        </Btn>

        <Btn
          variant="secondary"
          size="lg"
          onClick={() => handleDocumentAction("/extract/csv2qbo/")}
          className="d-flex flex-column align-items-center p-4 ml-3"
          style={{ minWidth: "200px" }}
        >
          <FontAwesomeIcon icon="file-alt" size="2x" className="mb-2" />
          <strong>Bank Transactions</strong>
          <small className="mt-1">Upload CSV files</small>
        </Btn>
      </div>
    </div>
  );

  const PageNumberCellRenderer = (props) => {
    if (!props.data) return "";
    return <span>{props.value}</span>;
  };

  const SwitchCellRenderer = (props) => {
    const [included, setIncluded] = React.useState(
      props.data ? props.data.included : false
    );

    if (!props.data) return "";
    const { documentId, fieldName, rowNumber } = props.data;

    return (
      <Switch
        key={included}
        checked={included}
        onChange={(e) => {
          dispatch(toggleLoading());
          const fn =
            l1 && l2
              ? createCorrectionTagLevel(
                  documentId,
                  l1,
                  l2,
                  fieldName,
                  rowNumber,
                  -1,
                  null,
                  !included,
                  false,
                  false
                )
              : job && job.id
              ? createCorrection(
                  job.id,
                  documentId,
                  fieldName,
                  rowNumber,
                  -1,
                  null,
                  !included,
                  false,
                  false
                )
              : Promise.resolve({ transactions: [] });
          fn.then(({ transactions }) => {
            // dispatch(setRefreshKey());
            setIncluded(!included);
            dispatch(toggleLoading());
            dispatch(setTls({ transactions, resetPages: false }));
            dispatch(fetchMfs());
            dispatch(fetchTotals());

            dispatch(
              createAlert({
                message: "Included transactions updated successfully",
                timeout: 0,
                type: "success",
              })
            );
          }).catch(() => {
            dispatch(toggleLoading());
            dispatch(
              createAlert({
                message: "Error updating included transactions. Please try again.",
                timeout: 0,
                type: "error",
              })
            );
          });
        }}
        onColor="#86d3ff"
        onHandleColor="#2693e6"
        handleDiameter={15}
        uncheckedIcon={false}
        checkedIcon={false}
        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
        height={10}
        width={30}
        className="react-switch"
        id="material-switch"
      />
    );
  };

  const EditableQboField = (props) => {
    const { field, fieldType, value } = props;

    const [value2, setValue2] = React.useState(value);

    if (!props.data) return "";

    const createCorrectionHelper = (
      newText,
      toggleSign,
      divideBy100,
      multilineIndex
    ) => {
      const values = props.data;
      const { documentId, fieldName, rowNumber, columnMapping, included } =
        values;

      // if (!job) {
      //   // console.warn("No job found, cannot create correction");
      //   return;
      // }

      // console.log("Creating correction with params:", {
      //   jobId: job.id,
      //   documentId,
      //   fieldName,
      //   rowNumber,
      //   columnIndex: columnMapping[props.field],
      //   newText,
      //   included,
      //   toggleSign,
      //   divideBy100,
      //   multilineIndex,
      // });
      dispatch(toggleLoading());
      const fn =
        l1 && l2
          ? createCorrectionTagLevel(
              documentId,
              l1,
              l2,
              fieldName,
              rowNumber,
              columnMapping[props.field],
              newText,
              included,
              toggleSign,
              divideBy100,
              multilineIndex
            )
          : job && job.id
          ? createCorrection(
              job.id,
              documentId,
              fieldName,
              rowNumber,
              columnMapping[props.field],
              newText,
              included,
              toggleSign,
              divideBy100,
              multilineIndex
            )
          : Promise.resolve({ transactions: [] });

      fn.then(({ transactions }) => {
        dispatch(toggleLoading());
        // // dispatch(setTls({ transactions, resetPages: false }));
        // dispatch(setRefreshKey());

        dispatch(fetchTotals());
        dispatch(fetchMfs());

        dispatch(
          createAlert({
            message: "Transaction fixed",
            timeout: 0,
            type: "success",
          })
        );
        if (gridApi.current) {
          gridApi.current.purgeInfiniteCache();
        }
      }).catch(() => {
        dispatch(toggleLoading());
        dispatch(
          createAlert({
            message: "Error fixing transaction. Please try again.",
            timeout: 0,
            type: "error",
          })
        );
      });
    };

    if (fieldType === "date") {
      return (
        <EditableFieldDateYYYYMMDD
          onSave={(newValue) => {
            createCorrectionHelper(newValue, false, false, null);
          }}
          value={value}
        />
      );
    } else if (fieldType === "number") {
      if (["amount", "balance", "debit", "credit"].includes(field)) {
        return (
          <Row className="align-items-center justify-content-between">
            <Col>
              <EditableFieldAmount
                key={value2}
                onSave={(newValue) => {
                  createCorrectionHelper(newValue, false, false, null);
                }}
                value={value2}
              />
            </Col>
            <Col className="px-0">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="flip-sign-tip">Flip sign (positive ↔ negative)</Tooltip>}
              >
                <Btn
                  className="p-0"
                  variant="tertiary"
                  size="sm"
                  onClick={() => {
                    createCorrectionHelper("", true, false, null);
                  }}
                >
                  +/-
                </Btn>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="divide-100-tip">Divide by 100 (fix off-by-2-decimal-places)</Tooltip>}
              >
                <Btn
                  className="p-0 ml-2"
                  variant="tertiary"
                  size="sm"
                  onClick={() => {
                    createCorrectionHelper("", false, true, null);
                  }}
                >
                  .00
                </Btn>
              </OverlayTrigger>
            </Col>
          </Row>
        );
      } else {
        return (
          <EditableFieldAmount
            onSave={(newValue) =>
              createCorrectionHelper(newValue, false, false, null)
            }
            value={value}
          />
        );
      }
    } else {
      // text
      if (isArray(value)) {
        const concatenatedValue = value.join(" ");
        return (
          <EditableFieldText
            onSave={(newValue) => {
              createCorrectionHelper(newValue, false, false, 0);
            }}
            value={concatenatedValue}
            multiline={true}
            placement="top"
          />
        );
      } else {
        return (
          <EditableFieldText
            onSave={(newValue) =>
              createCorrectionHelper(newValue, false, false, null)
            }
            value={value}
          />
        );
      }
    }
  };

  // Helper function to check if a transaction is AI-generated
  // Checks the metadata field (JSON string) for aiGenerated: true property
  const isAIGenerated = (rowData: any) => {
    if (!rowData || !rowData.metadata) return false;

    try {
      const metadata =
        typeof rowData.metadata === "string"
          ? JSON.parse(rowData.metadata)
          : rowData.metadata;
      return metadata.aiGenerated === true;
    } catch (err) {
      return false;
    }
  };

  // Row class helper for AI-generated styling
  // Applies 'ai-generated-row' CSS class to rows with AI-generated transactions
  const getRowClass = (params: any) => {
    const baseClass = "";
    if (isAIGenerated(params.data)) {
      return baseClass + " ai-generated-row";
    }
    return baseClass;
  };

  const defaultColumnDefs = [
    // {
    //   field: "selection",
    //   headerCheckboxSelection: true,
    //   checkboxSelection: true,
    //   width: 40,
    //   minWidth: 40,
    //   maxWidth: 40,
    //   pinned: "left",
    //   lockPosition: true,
    //   suppressMenu: true,
    //   index: -1,
    // },
    {
      field: "included",
      headerName: "Included",
      minWidth: 100,
      maxWidth: 100,
      cellRenderer: SwitchCellRenderer,
      cellClass: "ag-grid-cell-included",
      filter: false,
      floatingFilter: false,
      suppressMenu: true,
      sortable: false,
      index: 0,
    },
    {
      field: "pageNumber",
      headerName: "Page",
      filter: "agNumberColumnFilter",
      sortable: true,
      minWidth: 80,
      maxWidth: 120,
      // pageNumber is stored 0-indexed; expose the 1-indexed value to AG Grid
      // so filter and sort line up with what the user sees in the cell.
      valueGetter: (params: any) =>
        params.data ? parseInt(params.data.pageNumber, 10) + 1 : null,
      cellRenderer: PageNumberCellRenderer,
      index: 1,
    },
    {
      key: "documentDate",
      field: "date",
      filter: "agDateColumnFilter",
      filterParams: datefilterParamsYYYYMMDD,
      floatingFilterComponent: DateRangeFloatingFilter,
      floatingFilterComponentParams: { suppressFilterButton: true },
      sortable: true,
      minWidth: 200,
      cellRenderer: EditableQboField,
      cellRendererParams: {
        field: "date",
        fieldType: "date",
      },
      cellClass: "ag-grid-cell-date",
      configurable: true,
      index: 2,
    },
    {
      key: "documentDescription",
      field: "description",
      filterParams: {},
      minWidth: 400,
      cellRenderer: EditableQboField,
      cellRendererParams: {
        field: "name",
        fieldType: "text",
      },
      configurable: true,
      index: 3,
    },
    {
      key: "documentAmount",
      field: "amount",
      sortable: true,
      minWidth: 250,
      cellRenderer: EditableQboField,
      cellRendererParams: {
        field: "amount",
        fieldType: "number",
      },
      configurable: true,
      index: 4,
      filter: "agNumberColumnFilter",
      floatingFilterComponent: AmountRangeFloatingFilter,
      floatingFilterComponentParams: { suppressFilterButton: true },
    },
    {
      key: "documentDate2",
      field: "date2",
      filter: "agDateColumnFilter",
      filterParams: datefilterParamsYYYYMMDD,
      floatingFilterComponent: DateRangeFloatingFilter,
      floatingFilterComponentParams: { suppressFilterButton: true },
      sortable: true,
      minWidth: 200,
      cellRenderer: EditableQboField,
      cellRendererParams: {
        field: "date2",
        fieldType: "date",
      },
      configurable: true,
      index: 5,
    },
    {
      key: "documentPayee",
      field: "payee",
      filterParams: {},
      minWidth: 200,
      cellRenderer: EditableQboField,
      cellRendererParams: {
        field: "payee",
        fieldType: "text",
      },
      configurable: true,
      index: 6,
    },
    {
      key: "documentBalance",
      field: "balance",
      filter: "agNumberColumnFilter",
      filterParams: {},
      minWidth: 250,
      cellRenderer: EditableQboField,
      cellRendererParams: {
        field: "balance",
        fieldType: "number",
      },
      configurable: true,
      index: 7,
    },
    {
      key: "documentCheckNumber",
      field: "checkNumber",
      filterParams: {},
      minWidth: 150,
      cellRenderer: EditableQboField,
      cellRendererParams: {
        field: "checkNumber",
        fieldType: "text",
      },
      configurable: true,
      index: 8,
    },
  ];

  const reduxColumnDefs =
    useSelector(
      (state: ReduxState) => state.AgGridColumnConfig.transactionManager
    ) || [];

  const initialColumnDefs = useMemo(() => {
    // Strip app-internal metadata AG Grid doesn't recognize as colDef props.
    // `index`/`configurable` are consumed by ColumnSelector via redux; `key` is unused.
    const stripInternal = ({ key, index, configurable, ...rest }: any) => rest;

    if (reduxColumnDefs.length === 0) {
      const defaultColumns = defaultColumnDefs.map((col) => ({
        ...col,
        hide: false,
        width: (col as any).width,
      }));

      dispatch(
        setColumns({
          tableId: "transactionManager",
          columns: defaultColumns as any,
        })
      );
      return defaultColumns.map(stripInternal);
    }

    // Sort columns by index
    return reduxColumnDefs
      .slice()
      .sort((a, b) => (a as any).index - (b as any).index) // Sort by index
      .map((reduxCol) => {
        const defaultCol = defaultColumnDefs.find(
          (col) => col.field === reduxCol.field
        );
        return {
          ...defaultCol,
          hide:
            reduxCol.hide !== undefined
              ? reduxCol.hide
              : (defaultCol as any).hide,
          width:
            reduxCol.width !== undefined
              ? reduxCol.width
              : (defaultCol as any).width,
        };
      })
      .map(stripInternal);
  }, [reduxColumnDefs, dispatch]);

  const defaultColDef = React.useMemo(() => {
    return {
      resizable: true,
      filter: true,
      // Renders a small filter input directly under each column header — the
      // standard spreadsheet pattern. Lets users discover and apply column
      // filters in-place instead of via a separate chip row above the table.
      floatingFilter: true,
    };
  }, []);

  const { totalsByChunk } = useSelector(
    (state: ReduxState) => state.Reconciler
  );

  useEffect(() => {
    return () => {
      dispatch(setSelectedDocumentId(null)); // Assuming this action exists
      dispatch(setSelectedChunk(null));
      dispatch(setSelectedAccount(null));
    };
  }, []);

  const documents = tlsDocuments;

  const gridApi = useRef<any>(null);
  // Bumped in onSetApi so effects that depend on the grid api (notably
  // setDatasource) re-fire after onGridReady. Without this, when the Split
  // wrapper remounts on isCSV toggle, the new AgGrid instance comes online
  // *after* selectedDocumentId/selectedAccount/selectedChunk have settled,
  // so the setDatasource effect already ran with a null gridApi and bailed.
  const [gridApiTick, setGridApiTick] = useState(0);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);

  // ---- Bbox highlight + PDF panel collapse (Phase 2) ----
  // highlightBbox drives the amber overlay on the PDF canvas. lastClickedRowId
  // tracks the row whose bbox is currently being shown — independent of
  // selection. When 2+ rows are selected, we stop following selection and the
  // user can shift-click to set the highlight to the last clicked row.
  const [highlightBbox, setHighlightBbox] = useState<{
    page: number;
    x0: number;
    y0: number;
    x1: number;
    y1: number;
  } | null>(null);
  const [lastClickedRowId, setLastClickedRowId] = useState<any>(null);
  const pendingKeyboardBboxRef = useRef<NodeJS.Timeout | null>(null);

  // ---- PDF page follow + Prev/Next transaction navigation ----
  // pdfPage drives the viewer's page independently of highlightBbox, so we can
  // turn the page for a row even when it has no bbox (e.g. CSV-derived rows) and
  // for the period/document auto-jump (item F) where there is no clicked row.
  const [pdfPage, setPdfPage] = useState<number | undefined>(undefined);
  // Index (within the grid's row set) of the transaction currently linked to
  // the PDF. Ref mirror keeps Prev/Next in sync without stale closures.
  const [currentRowIndex, setCurrentRowIndex] = useState<number | null>(null);
  const currentRowIndexRef = useRef<number | null>(null);
  const setCurrentRowIndexBoth = useCallback((idx: number | null) => {
    currentRowIndexRef.current = idx;
    setCurrentRowIndex(idx);
  }, []);
  // Auto-jump-to-first-transaction bookkeeping (item F). We only auto-jump once
  // per document/account/period so it never fights the user's manual paging.
  const autoJumpKeyRef = useRef<string | null>(null);
  const needsAutoJumpRef = useRef<boolean>(false);

  // 1-indexed PDF page for a row. Prefer the bbox page (authoritative, already
  // 1-indexed); fall back to the stored 0-indexed pageNumber + 1.
  const pageForRow = useCallback(
    (row: any): number | undefined => {
      const b = row && row.bbox;
      if (b && typeof b.page === "number") return b.page;
      const raw = row && row.pageNumber;
      if (raw !== null && raw !== undefined && !isNaN(parseInt(raw, 10))) {
        return parseInt(raw, 10) + 1;
      }
      return undefined;
    },
    []
  );

  // PDF panel collapse — persisted across reloads.
  const PDF_PANEL_COLLAPSED_KEY = "docuclipper.review.pdfPanelCollapsed";
  const [pdfPanelCollapsed, setPdfPanelCollapsed] = useState<boolean>(() => {
    try {
      return localStorage.getItem(PDF_PANEL_COLLAPSED_KEY) === "1";
    } catch {
      return false;
    }
  });
  useEffect(() => {
    try {
      localStorage.setItem(
        PDF_PANEL_COLLAPSED_KEY,
        pdfPanelCollapsed ? "1" : "0"
      );
    } catch {
      /* ignore */
    }
  }, [pdfPanelCollapsed]);

  // Helper: extract a bbox-like object from a row (defensive — only set if
  // the shape is what we expect; rows with bbox: null fall through silently).
  const extractBbox = useCallback((row: any) => {
    const b = row && row.bbox;
    if (
      !b ||
      typeof b !== "object" ||
      typeof b.page !== "number" ||
      typeof b.x0 !== "number" ||
      typeof b.y0 !== "number" ||
      typeof b.x1 !== "number" ||
      typeof b.y1 !== "number"
    ) {
      return null;
    }
    // The stored bbox is the date token's box (narrow). Users expect the whole
    // transaction LINE highlighted, so span the page's content width
    // (~0.03..0.97 of page width) while keeping the row's own vertical extent.
    // Math.min/max so an already-wide box (some banks) is never shrunk.
    return {
      page: b.page,
      x0: Math.min(b.x0, 0.03),
      y0: b.y0,
      x1: Math.max(b.x1, 0.97),
      y1: b.y1,
    };
  }, []);

  // Apply highlight from a row immediately (mouse path).
  const applyHighlightFromRow = useCallback(
    (row: any) => {
      if (pendingKeyboardBboxRef.current) {
        clearTimeout(pendingKeyboardBboxRef.current);
        pendingKeyboardBboxRef.current = null;
      }
      const bbox = extractBbox(row);
      setHighlightBbox(bbox);
      setPdfPage(pageForRow(row));
    },
    [extractBbox, pageForRow]
  );

  // Apply highlight from a row debounced (keyboard repeat path).
  const applyHighlightFromRowDebounced = useCallback(
    (row: any) => {
      if (pendingKeyboardBboxRef.current) {
        clearTimeout(pendingKeyboardBboxRef.current);
      }
      pendingKeyboardBboxRef.current = setTimeout(() => {
        const bbox = extractBbox(row);
        setHighlightBbox(bbox);
        setPdfPage(pageForRow(row));
        pendingKeyboardBboxRef.current = null;
      }, 150);
    },
    [extractBbox, pageForRow]
  );

  // Focus + link a specific row node to the PDF (used by Prev/Next). Setting
  // the focused cell makes AG Grid apply .ag-row-focus, which is what styles the
  // linked row (amber accent) — matching the PDF highlight color for a clear tie.
  const applyRowFocus = useCallback(
    (node: any, index: number) => {
      const row = node && node.data;
      if (!row) return;
      setCurrentRowIndexBoth(index);
      setLastClickedRowId(row.id);
      const api = gridApi.current;
      if (api) {
        try {
          api.ensureIndexVisible(index, "middle");
        } catch (_) {
          /* ignore */
        }
        // "included" is the always-present, non-configurable first data column.
        try {
          api.setFocusedCell(index, "included");
        } catch (_) {
          /* ignore */
        }
      }
      setHighlightBbox(extractBbox(row));
      setPdfPage(pageForRow(row));
    },
    [extractBbox, pageForRow, setCurrentRowIndexBoth]
  );

  // Move the linked transaction by +/-1 through the grid's row order and follow
  // it in the PDF. Handles the infinite row model: after ensuring the target
  // index is visible (which triggers a block load if needed), we poll briefly
  // for the row data to arrive. Boundaries: clamped at 0; a null node past the
  // end is a no-op.
  const navigateRow = useCallback(
    (delta: number) => {
      const api = gridApi.current;
      if (!api) return;
      const base =
        currentRowIndexRef.current == null ? -1 : currentRowIndexRef.current;
      const target = Math.max(0, base + delta);
      try {
        api.ensureIndexVisible(target, "middle");
      } catch (_) {
        /* ignore */
      }
      let attempts = 0;
      const tryApply = () => {
        const node = api.getDisplayedRowAtIndex(target);
        if (node && node.data) {
          applyRowFocus(node, target);
        } else if (node && attempts < 12) {
          // Row exists but its block hasn't loaded yet (infinite model).
          attempts += 1;
          setTimeout(tryApply, 120);
        }
        // node == null => past the end of the data: no-op (boundary).
      };
      tryApply();
    },
    [applyRowFocus]
  );

  // Reset the PDF link + arm the auto-jump whenever the active document /
  // account / period changes (item F). The actual page jump happens once the
  // first block of rows loads (see getRows successCallback).
  useEffect(() => {
    const key = `${selectedDocumentId}|${selectedAccount}|${selectedChunk}`;
    if (autoJumpKeyRef.current === key) return;
    autoJumpKeyRef.current = key;
    setCurrentRowIndexBoth(null);
    setHighlightBbox(null);
    setPdfPage(undefined);
    // Only arm the jump when there's a document to show a page from.
    needsAutoJumpRef.current = !isNullOrUndefined(selectedDocumentId);
  }, [
    selectedDocumentId,
    selectedAccount,
    selectedChunk,
    setCurrentRowIndexBoth,
  ]);

  useEffect(() => {
    return () => {
      if (pendingKeyboardBboxRef.current) {
        clearTimeout(pendingKeyboardBboxRef.current);
      }
    };
  }, []);

  // Store the API instance in Redux when it changes
  useEffect(() => {
    if (gridApi.current) {
      dispatch(setGridApi(gridApi.current));
    }
  }, [dispatch, gridApiTick]);

  const externalFilterColumns = React.useMemo(
    () => [
      {
        field: "pageNumber",
        label: "Page Number",
        filter: true,
        filterType: "number",
        defaultFilterType: "equals",
      },
      {
        field: "description",
        label: "Description",
        filter: true,
        configurable: true,
        filterType: "text",
        defaultFilterType: "contains",
      },
      {
        field: "amount",
        label: "Amount",
        filter: true,
        filterType: "number",
        defaultFilterType: "equals",
        configurable: true,
      },
      {
        field: "date",
        label: "Date",
        filter: true,
        filterType: "date",
        defaultFilterType: "equals",
        configurable: true,
      },
      {
        field: "date2",
        label: "Date 2",
        filter: true,
        filterType: "date",
        defaultFilterType: "equals",
      },
      {
        field: "balance",
        label: "Balance",
        filter: true,
        filterType: "number",
        defaultFilterType: "equals",
      },
      {
        field: "checkNumber",
        label: "Check Number",
        filter: true,
        filterType: "text",
        defaultFilterType: "equals",
      },
    ],
    []
  );
  const { isAdmin, isSupportRep } = useIsAdmin();
  const chunkData = useChunkData();

  const paginationPageSizeSelector = React.useMemo(() => {
    return [20, 50, 100];
  }, []);

  useEffect(() => {
    dispatch(clearExternalFilters());
    dispatch(
      setExternalFiltersColumnDefs({
        externalFilterColumnDefs: initialColumnDefs,
      })
    );
  }, [selectedDocumentId]);

  const { pdfURL } = useBankStatementPDF({
    selectedDocumentId,
  });

  const onColumnResized = useCallback(
    (event) => {
      if (event.finished) {
        const columnState = event.columnApi.getColumnState();

        columnState.forEach((column) => {
          if (column.width) {
            dispatch(
              setColumnWidth({
                tableId: "transactionManager",
                field: column.colId,
                width: column.width,
              })
            );
          }
        });
      }
    },
    [dispatch]
  );

  const hasQbo = useHasQbo();

  // console.log({ selectedAccount, selectedChunk, selectedDocumentId });
  React.useEffect(() => {
    if (
      !isNullOrUndefined(selectedAccount) &&
      !isNullOrUndefined(selectedDocumentId) &&
      (selectedAccount || "") in totalsByChunk &&
      (selectedDocumentId || "") in totalsByChunk[selectedAccount || ""]
    ) {
      const chunksInAccount =
        totalsByChunk[selectedAccount || ""][selectedDocumentId || ""];
      const chunks = Object.keys(chunksInAccount);

      dispatch(setAccountChunks(chunks));
      if (chunks.length > 0 && (!selectedChunk || !chunks.includes(selectedChunk))) {
        dispatch(setSelectedChunk(chunks[0]));
      }
    }
  }, [selectedAccount, selectedDocumentId, totalsByChunk]);

  // console.log({ selectedAccount, selectedChunk });
  const getRows = useCallback(
    (params) => {
      dispatch(
        fetchTls(false, {
          pagination: {
            page: Math.floor(params.startRow / paginationPageSize) + 1,
            pageSize: params.endRow - params.startRow,
          },
          filters: [
            ...(selectedDocumentId
              ? [
                  {
                    field: "documentId",
                    operator: "equals" as const,
                    value: selectedDocumentId,
                  },
                ]
              : []),
            ...(selectedAccount
              ? [
                  {
                    field: "account",
                    operator: "equals" as const,
                    value: selectedAccount,
                  },
                ]
              : []),
            ...(selectedChunk
              ? [
                  {
                    field: "chunk",
                    operator: "equals" as const,
                    value: selectedChunk,
                  },
                ]
              : []),
            // pageNumber is stored 0-indexed but displayed 1-indexed via the
            // column's valueGetter. The grid filter uses the value the user
            // typed (1-indexed), so translate it back to the storage form
            // before sending to the server.
            ...convertFilterModel(params).map((f) =>
              f.field === "pageNumber"
                ? {
                    ...f,
                    value: f.value != null ? Number(f.value) - 1 : f.value,
                    valueFrom:
                      f.valueFrom != null
                        ? Number(f.valueFrom) - 1
                        : f.valueFrom,
                    valueTo:
                      f.valueTo != null ? Number(f.valueTo) - 1 : f.valueTo,
                  }
                : f
            ),
          ],
          sorting: convertSortModel(params.sortModel),
          successCallback: (rowsThisPage, lastRow) => {
            // Process rows to include metadata for AI-generated detection
            const processedRows = rowsThisPage.map((row) => ({
              ...row,
              // Ensure metadata is available for AI detection
              metadata: row.metadata || null,
            }));
            params.successCallback(processedRows, lastRow);

            // Item F: on the first block after a document/account/period change,
            // jump the PDF to the FIRST transaction's page (min pageNumber) and
            // highlight it. Guarded by needsAutoJumpRef so it fires exactly once
            // and never fights the user's later manual paging.
            if (
              params.startRow === 0 &&
              needsAutoJumpRef.current &&
              processedRows.length > 0
            ) {
              needsAutoJumpRef.current = false;
              let bestIdx = 0;
              let bestPage = pageForRow(processedRows[0]);
              processedRows.forEach((r, i) => {
                const p = pageForRow(r);
                if (
                  p !== undefined &&
                  (bestPage === undefined || p < bestPage)
                ) {
                  bestPage = p;
                  bestIdx = i;
                }
              });
              const best = processedRows[bestIdx];
              setCurrentRowIndexBoth(bestIdx);
              setHighlightBbox(extractBbox(best));
              setPdfPage(pageForRow(best));
            }
          },
          documents,
          hasQbo,
          job,
          l1,
          l2,
        })
      );
    },
    [
      dispatch,
      paginationPageSize,
      selectedDocumentId,
      selectedAccount,
      selectedChunk,
      documents,
      hasQbo,
      job,
      refreshKey,
      l1,
      l2,
    ]
  );

  // Keep a ref to the latest getRows so the IDatasource identity stays stable.
  // Without this, every render produced a new dataSource and the setDatasource
  // effect below cleared + refetched the grid (visible flash).
  const getRowsRef = useRef(getRows);
  useEffect(() => {
    getRowsRef.current = getRows;
  }, [getRows]);

  const dataSource: IDatasource = useMemo(
    () => ({
      rowCount: undefined,
      getRows: (params) => getRowsRef.current(params),
    }),
    []
  );

  useEffect(() => {
    if (!gridApi.current) {
      return;
    }

    if (
      // !job ||
      // ["InProgress", "Finishing", "Canceled"].includes(job.status) ||
      isNullOrUndefined(selectedDocumentId) ||
      isNullOrUndefined(selectedAccount) ||
      isNullOrUndefined(selectedChunk)
    ) {
      return;
    }

    gridApi.current.setDatasource(dataSource);
  }, [
    job,
    selectedDocumentId,
    selectedAccount,
    selectedChunk,
    refreshKey,
    externalFilters,
    gridApiTick,
  ]);

  const [showColumnSelectorModal, setShowColumnSelectorModal] = useState(false);

  const handleShow = () => setShowColumnSelectorModal(true);
  const handleClose = () => setShowColumnSelectorModal(false);

  const tableId = "transactionManager";

  const [isSelectAllPages, setIsSelectAllPages] = useState(false);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [deselectedRows, setDeselectedRows] = useState<Set<string>>(new Set());

  // "Bulk edit" modal (set one field's value across the selected rows).
  const [showBulkEditModal, setShowBulkEditModal] = useState(false);
  const [bulkEditFieldKey, setBulkEditFieldKey] = useState<string>("");
  const [bulkEditValue, setBulkEditValue] = useState<string>("");

  const buildSelectAllFilterParams = useCallback(() => {
    return {
      filters: [
        ...(selectedDocumentId
          ? [
              {
                field: "documentId",
                operator: "equals" as const,
                value: selectedDocumentId,
              },
            ]
          : []),
        ...(selectedAccount
          ? [
              {
                field: "account",
                operator: "equals" as const,
                value: selectedAccount,
              },
            ]
          : []),
        ...(selectedChunk
          ? [
              {
                field: "chunk",
                operator: "equals" as const,
                value: selectedChunk,
              },
            ]
          : []),
        ...convertFilterModel({
          filterModel: gridApi.current?.getFilterModel?.() || {},
        }),
        ...(deselectedRows.size > 0
          ? [
              {
                field: "id",
                operator: "notIn" as const,
                value: Array.from(deselectedRows),
              },
            ]
          : []),
      ],
    };
  }, [selectedDocumentId, selectedAccount, selectedChunk, deselectedRows]);

  const bulkEditHelper = (
    operation: string,
    transactionIds: any[],
    extraParams: { [k: string]: any } = {}
  ) => {
    if (isSelectAllPages) {
      dispatch(toggleLoading());

      const filterParams = buildSelectAllFilterParams();

      const fn =
        l1 && l2
          ? performBulkEditTagLevel({
              l1,
              l2,
              operation,
              params: { ...filterParams, ...extraParams },
              transactionIds: [], // Empty array since we're using filters
            })
          : job && job.id
          ? performBulkEdit({
              jobId: job.id,
              operation,
              params: { ...filterParams, ...extraParams },
              transactionIds: [], // Empty array since we're using filters
            })
          : Promise.resolve({ transactions: [] });

      return fn
        .then(({ transactions }) => {
          dispatch(toggleLoading());
          dispatch(fetchMfs());
          dispatch(fetchTotals());

          if (gridApi.current) {
            gridApi.current.purgeInfiniteCache();
          }

          dispatch(
            createAlert({
              message: "Correction made successfully",
              timeout: 0,
              type: "success",
            })
          );
        })
        .catch((err) => {
          dispatch(toggleLoading());
          dispatch(
            createAlert({
              message: "Error making correction. Please try again.",
              timeout: 0,
              type: "error",
            })
          );
        });
    } else {
      // Original implementation for specific transaction IDs
      dispatch(toggleLoading());
      const fn =
        l1 && l2
          ? performBulkEditTagLevel({
              l1,
              l2,
              operation,
              params: { ...extraParams },
              transactionIds,
            })
          : job && job.id
          ? performBulkEdit({
              jobId: job.id,
              operation,
              params: { ...extraParams },
              transactionIds,
            })
          : Promise.resolve({ transactions: [] });
      return fn
        .then(({ transactions }) => {
          dispatch(toggleLoading());
          dispatch(fetchMfs());
          dispatch(fetchTotals());

          if (gridApi.current) {
            gridApi.current.purgeInfiniteCache();
          }

          dispatch(
            createAlert({
              message: "Correction made successfully",
              timeout: 0,
              type: "success",
            })
          );
        })
        .catch((err) => {
          dispatch(toggleLoading());
          dispatch(
            createAlert({
              message: "Error making correction. Please try again.",
              timeout: 0,
              type: "error",
            })
          );
        });
    }
  };

  const handleSelectAll = useCallback(() => {
    if (!gridApi.current) return;
    setIsSelectAllPages(true);
    setDeselectedRows(new Set()); // Reset deselected rows
    const totalRows = gridApi.current.getInfiniteRowCount();
    setTotalRowCount(totalRows || 0);
    gridApi.current.forEachNode((node) => {
      node.setSelected(true);
    });
  }, []);

  const handleClearSelection = useCallback(() => {
    setIsSelectAllPages(false);
    setTotalRowCount(0);
    setDeselectedRows(new Set()); // Reset deselected rows
    if (gridApi.current) {
      gridApi.current.deselectAll();
    }
  }, []);

  // Select-all is scoped to the active document + account + period that was
  // visible when the user clicked it. If any of those change, drop the flag
  // so the toolbar doesn't follow the user across periods and silently keep
  // auto-selecting newly-loaded rows via onPaginationChanged.
  useEffect(() => {
    if (isSelectAllPages) {
      handleClearSelection();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDocumentId, selectedAccount, selectedChunk]);

  // console.log({ page: pagination.page });

  // NOTE: We deliberately do NOT short-circuit on `loading` here. Earlier
  // we returned a centered <Spinner/> when (jobDocs empty && loading), which
  // unmounted AgGrid during the initial fetch. AgGrid sets `gridApi.current`
  // asynchronously via `onGridReady` after it mounts — so when the spinner
  // unmounted the grid, the subsequent `selectedDocumentId` change fired the
  // setDatasource effect *before* the new grid instance was ready, the
  // effect bailed on `if (!gridApi.current) return;`, and the grid never
  // received its datasource. Net result: transactions never loaded.
  // Letting AgGrid mount during the loading phase (as before) lets onGridReady
  // populate the ref while jobDocs is still in flight, so by the time
  // setSelectedDocumentId fires the ref is live and setDatasource takes.

  // Show empty state if no job documents
  if ((!jobDocs || jobDocs.length === 0) && !loading) {
    return (
      <div>
      {!hideJobButtons && (
        <Row className="justify-content-end text-right px-2 mb-1">
          <TransactionManagerTourAndReportIssue />
          <HelpDrawer docType="bank" />
          <DownloadModal jobType={"bank"} btnVariant={"primary"} />
        </Row>
      )}
        <Row>
          <Col md="12">
            <EmptyStateComponent />
          </Col>
        </Row>
      </div>
    );
  }

  return (
    <div>
      {/* {l1 && l2 && ( */}
      {!hideJobButtons && (
        <Row className="justify-content-end text-right px-2 mb-1">
          <TransactionManagerTourAndReportIssue />
          <HelpDrawer docType="bank" />
          <DownloadModal jobType={"bank"} btnVariant={"primary"} />
        </Row>
      )}
      <Row>
        <Col md="12" className="new-transactions">
          <Split
            // react-split / split.js builds an internal `pairs` array on
            // mount and never reconciles with a changed children count.
            // When isCSV toggles, the conditional PDF pane below adds or
            // removes a child and the next setSizes call crashes with
            // `Cannot read properties of undefined (reading 'a')` inside
            // pair[i-1] (DOCUCLIPPER-349, ~338 users). Keying on isCSV
            // forces a clean remount with the correct child count.
            // Phase 2 note: pdfPanelCollapsed adds a 3rd key so toggling
            // collapse remounts the splitter cleanly with the new sizes.
            key={`${isCSV ? "csv" : "pdf"}-${pdfPanelCollapsed ? "c" : "e"}`}
            sizes={
              isCSV ? [0, 100] : pdfPanelCollapsed ? [0, 100] : [40, 60]
            }
            minSize={isCSV || pdfPanelCollapsed ? 0 : 100}
            gutterSize={isCSV || pdfPanelCollapsed ? 0 : 10}
            direction="horizontal"
            style={{ display: "flex", height: "90vh" }}
          >
            {isCSV || pdfPanelCollapsed ? (
              // split.js requires >=2 children to size them correctly; with a
              // single child it leaves the pane sized weirdly (collapsed
              // Account/Period selectors, balance strip wrapping cell-per-row).
              // Render an empty 0-width placeholder so the right pane gets
              // the full sizes={[0, 100]} width — and so the collapsed PDF
              // pane is genuinely 0 visible pixels rather than a thin strip
              // with a Hide-PDF button still peeking through.
              <div style={{ width: 0, height: "100%" }} />
            ) : (
              <div
                style={{
                  width: "100%",
                  paddingRight: "0.75rem",
                  display: "flex",
                  flexDirection: "column",
                  position: "relative",
                  // When the user collapses the PDF panel, react-split sets
                  // this pane's width to 0 via sizes={[0,100]} but does NOT
                  // clip the children. Without overflow:hidden the PDF
                  // toolbar + canvas overflow rightward and cover the
                  // "Show PDF" rail in the adjacent table pane (rendering
                  // it invisible / unclickable). Clip here so the rail is
                  // reachable while collapsed.
                  overflow: "hidden",
                }}
                className="pdf-pane"
              >
                {/* Top bar: transaction navigation (left) + collapse (right). */}
                <div
                  className="d-flex align-items-center justify-content-between"
                  style={{ marginBottom: 4 }}
                >
                  {/* Prev/Next transaction — steps the linked row through the
                      table in order and follows it in the PDF (item E). The
                      label + position counter make it clear you're walking
                      through transactions and which one is highlighted. */}
                  <div className="d-flex align-items-center">
                    <span className="small font-weight-bold text-muted mr-2">
                      Review transactions
                    </span>
                    <ButtonGroup size="sm">
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id="prev-txn-tip">
                            Previous transaction (highlights it in the PDF).
                            Arrow keys work in the table too.
                          </Tooltip>
                        }
                      >
                        <Button
                          variant="outline-primary"
                          disabled={(currentRowIndex ?? 0) <= 0}
                          onClick={() => navigateRow(-1)}
                          aria-label="Previous transaction"
                        >
                          <FontAwesomeIcon icon="chevron-up" /> Prev
                        </Button>
                      </OverlayTrigger>
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id="next-txn-tip">
                            Next transaction (highlights it in the PDF). Arrow
                            keys work in the table too.
                          </Tooltip>
                        }
                      >
                        <Button
                          variant="outline-primary"
                          onClick={() => navigateRow(1)}
                          aria-label="Next transaction"
                        >
                          Next <FontAwesomeIcon icon="chevron-down" />
                        </Button>
                      </OverlayTrigger>
                    </ButtonGroup>
                    <span
                      className="small text-muted ml-2"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      {currentRowIndex != null
                        ? `Transaction ${currentRowIndex + 1}${
                            totalRowCount ? ` of ${totalRowCount}` : ""
                          }`
                        : "Click a transaction or Next to start"}
                    </span>
                  </div>

                  {/* Collapse handle — top-right of PDF pane. */}
                  <button
                    type="button"
                    onClick={() => setPdfPanelCollapsed(true)}
                    title="Hide PDF"
                    aria-label="Hide PDF"
                    style={{
                      border: "1px solid #d0d7de",
                      background: "#fff",
                      borderRadius: 4,
                      padding: "2px 8px",
                      fontSize: 12,
                      color: "#57606a",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: 4,
                    }}
                  >
                    <FontAwesomeIcon icon="chevron-left" />
                    <span>Hide PDF</span>
                  </button>
                </div>
                {/*
                  Document picker used to live here, inside the PDF pane.
                  When the user collapsed the panel the picker collapsed
                  with it, so they could no longer switch documents while
                  in PDF-hidden mode. The picker now sits in the
                  account-period strip below alongside Account / Period.
                */}
                <div style={{ flex: 1, minHeight: 0 }}>
                  {selectedDocumentId && (
                    <PresignedDocumentViewer
                      key={`${l1 ?? ""}-${l2 ?? ""}-${selectedDocumentId}`}
                      documentId={selectedDocumentId}
                      highlightBbox={highlightBbox}
                      pageNumber={pdfPage}
                    />
                  )}
                </div>
              </div>
            )}
            <div
              style={{
                width: "100%",
                paddingLeft: "1.5rem",
                paddingRight: 0,
                position: "relative",
              }}
              className="transaction-manager"
            >
              {/*
                "Show PDF" restore. The previous implementation was a
                28-px-wide vertical rail pinned at right:0 of the table
                pane. AgGrid often overflows horizontally, and the rail
                ended up clipped behind the page's horizontal scrollbar
                with no way for the user to reach it. Inline button at the
                top of the pane is impossible to lose.
              */}
              {pdfPanelCollapsed && !isCSV && (
                <div className="d-flex justify-content-start mb-2">
                  <button
                    type="button"
                    onClick={() => setPdfPanelCollapsed(false)}
                    title="Show PDF"
                    aria-label="Show PDF"
                    style={{
                      border: "1px solid #d0d7de",
                      background: "#fff",
                      borderRadius: 4,
                      padding: "4px 10px",
                      fontSize: 12,
                      color: "#57606a",
                      cursor: "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 6,
                    }}
                  >
                    <FontAwesomeIcon icon="chevron-left" />
                    <span>Show PDF</span>
                  </button>
                </div>
              )}
              <SummaryTableAccountViewHorizontal2 section="account-period" />
              <SummaryTableAccountViewHorizontal2 section="balances" />
              {/*
                Toolbar above the table. Column-level filters live in the AG
                Grid floatingFilter row directly below each column header (see
                defaultColDef.floatingFilter), so the legacy chip row is gone.
                Only view-config + Add Transaction stay here, right-aligned.
              */}
              <div className="d-flex justify-content-end align-items-center mb-2 flex-wrap toolbar-row toolbar-actions">
                <Btn
                  variant="tertiary"
                  size="sm"
                  onClick={handleShow}
                  className="mx-1"
                >
                  <FontAwesomeIcon icon="cog" className="mr-2" />
                  Configure Columns
                </Btn>

                <div className="mx-1">
                  <AddTransactionModal
                    buttonVariant="light"
                    extended={true}
                    onTransactionAdded={() => {
                      if (gridApi.current) {
                        gridApi.current.purgeInfiniteCache();
                      }
                    }}
                  />
                </div>
                <div className="mx-1">
                  <PayeeCleanerConfig />
                </div>
              </div>

              <Modal show={showColumnSelectorModal} onHide={handleClose}>
                <Modal.Header
                  closeButton
                  placeholder=""
                  onPointerEnterCapture={() => {}}
                  onPointerLeaveCapture={() => {}}
                >
                  <Modal.Title>Configure Columns</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <ColumnSelector tableId={tableId} />
                </Modal.Body>
                <Modal.Footer>
                  <Btn variant="tertiary" onClick={handleClose}>
                    Close
                  </Btn>
                </Modal.Footer>
              </Modal>

              <AgBulkTable
                onSetApi={(api) => {
                  gridApi.current = api;
                  setGridApiTick((t) => t + 1);
                }}
                columnDefs={initialColumnDefs}
                bulkOpsClassName={"new-transactions-bulk-operations"}
                getRowClass={getRowClass}
                rowData={undefined}
                onCellClicked={(event: any) => {
                  // Mouse path: immediate. Track lastClickedRowId
                  // independent of selection so shift-click in a multi-select
                  // still drives the highlight.
                  const row = event && event.data;
                  if (!row) return;
                  setLastClickedRowId(row.id);
                  if (typeof event.rowIndex === "number") {
                    setCurrentRowIndexBoth(event.rowIndex);
                  }
                  // If the user has 2+ rows selected via checkboxes / shift-
                  // select, stop following selection — but still honor the
                  // explicit click as the new highlight target.
                  applyHighlightFromRow(row);
                }}
                onCellKeyDown={(event: any) => {
                  // Keyboard path: debounce so holding arrow keys doesn't
                  // whip the PDF panel through 50 pages.
                  const key =
                    event && event.event && (event.event as any).key;
                  if (
                    key !== "ArrowUp" &&
                    key !== "ArrowDown" &&
                    key !== "PageUp" &&
                    key !== "PageDown" &&
                    key !== "Home" &&
                    key !== "End"
                  ) {
                    return;
                  }
                  const row = event && event.data;
                  if (!row) return;
                  setLastClickedRowId(row.id);
                  if (typeof event.rowIndex === "number") {
                    setCurrentRowIndexBoth(event.rowIndex);
                  }
                  applyHighlightFromRowDebounced(row);
                }}
                onRowSelected={(event) => {
                  // Multi-select policy: when selection comes from the
                  // header checkbox / select-all / API path (no explicit
                  // row click), and 2+ rows end up selected, clear the
                  // highlight so the PDF panel stops following selection.
                  // Explicit shift/ctrl row clicks still flow through
                  // onCellClicked first (last-clicked wins).
                  try {
                    const source = (event as any).source;
                    const api = gridApi.current;
                    if (
                      api &&
                      (source === "uiSelectAll" ||
                        source === "apiSelectAll" ||
                        source === "checkboxSelected" ||
                        source === "rowDataChanged")
                    ) {
                      const selected = api.getSelectedRows
                        ? api.getSelectedRows()
                        : [];
                      if (selected.length >= 2) {
                        setHighlightBbox(null);
                      } else if (
                        selected.length === 1 &&
                        source === "checkboxSelected" &&
                        event.node &&
                        event.node.isSelected() &&
                        typeof event.node.rowIndex === "number"
                      ) {
                        // Single-row selection: follow it in the PDF (jump +
                        // whole-line highlight), same as a click / Prev-Next.
                        applyRowFocus(event.node, event.node.rowIndex);
                      }
                    }
                  } catch {
                    /* ignore */
                  }
                  if (isSelectAllPages && event.node.data) {
                    const rowId = event.node.data.id;
                    setDeselectedRows((prev) => {
                      const newSet = new Set(prev);
                      if (!event.node.isSelected()) {
                        newSet.add(rowId);
                      } else {
                        newSet.delete(rowId);
                      }
                      return newSet;
                    });
                  }
                }}
                // onGridReady={() => {
                //   if (isSelectAllPages && gridApi.current) {
                //     gridApi.current.forEachNode((node) => {
                //       if (node.data && !deselectedRows.has(node.data.id)) {
                //         node.setSelected(true);
                //       }
                //     });
                //   }
                // }}
                onPaginationChanged={() => {
                  if (isSelectAllPages && gridApi.current) {
                    gridApi.current.forEachNode((node) => {
                      if (node.data && !deselectedRows.has(node.data.id)) {
                        node.setSelected(true);
                      }
                    });
                  }
                }}
                renderBulkOps={(data, setSelectedRowsIds) => {
                  const transactionIds = data.map((x) => x.id);
                  const hasSelection = data.length > 0;
                  // Always render the bulk toolbar so users can discover the
                  // available actions. Disable each button when no rows are
                  // selected; an OverlayTrigger tooltip explains "Select rows
                  // to apply this action". Now that the .toolbar-actions
                  // styling clearly distinguishes enabled vs disabled, the
                  // greyed-out state reads as intentional, not as "broken".
                  const selectionText = !hasSelection
                    ? "Select rows to apply bulk actions"
                    : isSelectAllPages
                      ? deselectedRows.size > 0
                        ? `${
                            totalRowCount - deselectedRows.size
                          } transactions selected`
                        : `${totalRowCount} transactions selected`
                      : `${data.length} transactions selected`;
                  const disabledTip = "Select one or more rows first";
                  // How many rows a bulk action will affect (used in the
                  // Bulk edit modal's blast-radius message).
                  const affectedCount = isSelectAllPages
                    ? deselectedRows.size > 0
                      ? totalRowCount - deselectedRows.size
                      : totalRowCount
                    : data.length;
                  const bulkEditFieldDef = BULK_EDIT_FIELDS.find(
                    (f) => f.key === bulkEditFieldKey
                  );
                  const bulkEditValidationError = bulkEditFieldDef
                    ? validateBulkEditValue(bulkEditFieldDef.type, bulkEditValue)
                    : "No field selected";
                  const applyBulkEdit = () => {
                    if (!bulkEditFieldDef || bulkEditValidationError) return;
                    const operation =
                      bulkEditFieldDef.operation || "updateField";
                    const params =
                      operation === "updateCategory"
                        ? { category: bulkEditValue }
                        : { col: bulkEditFieldDef.col, newValue: bulkEditValue };
                    bulkEditHelper(operation, transactionIds, params).then(
                      () => {
                        setShowBulkEditModal(false);
                        setBulkEditFieldKey("");
                        setBulkEditValue("");
                        if (setSelectedRowsIds) {
                          setSelectedRowsIds({});
                        }
                      }
                    );
                  };
                  const wrapDisabled = (key: string, btn: JSX.Element) =>
                    !hasSelection ? (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id={`bulk-tip-${key}`}>{disabledTip}</Tooltip>
                        }
                      >
                        <span style={{ display: "inline-block" }}>{btn}</span>
                      </OverlayTrigger>
                    ) : (
                      btn
                    );

                  return (
                    <>
                    <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap bulk-edit-buttons toolbar-row">
                      <div className="d-flex align-items-center flex-wrap toolbar-actions">
                        <span
                          className={`mr-3 ${
                            hasSelection ? "font-weight-bold" : "text-muted"
                          }`}
                        >
                          {selectionText}
                        </span>
                        {wrapDisabled(
                          "clear",
                          <Btn
                            variant="tertiary"
                            size="sm"
                            disabled={!hasSelection}
                            onClick={handleClearSelection}
                            className="mx-1"
                          >
                            <FontAwesomeIcon icon="times" className="mr-1" />
                            Clear
                          </Btn>,
                        )}
                        {!isSelectAllPages && (
                          <Btn
                            variant="tertiary"
                            size="sm"
                            onClick={handleSelectAll}
                            className="mx-1"
                          >
                            <FontAwesomeIcon
                              icon="check-square"
                              className="mr-1"
                            />
                            Select all
                          </Btn>
                        )}
                      </div>
                      <div className="d-flex align-items-center flex-wrap toolbar-actions">
                        {wrapDisabled(
                          "assign",
                          <span style={{ display: "inline-block" }}>
                            <SelectAccount2
                              transactionIds={transactionIds}
                              setSelectionError={() => null}
                              bulkFilters={
                                isSelectAllPages
                                  ? buildSelectAllFilterParams()
                                  : null
                              }
                              onDone={() => {
                                setSelectedRowsIds([]);
                                handleClearSelection();
                                if (gridApi.current) {
                                  gridApi.current.purgeInfiniteCache();
                                }
                              }}
                            />
                          </span>,
                        )}
                        {wrapDisabled(
                          "switch-signs",
                          <Btn
                            variant="tertiary"
                            size="sm"
                            disabled={!hasSelection}
                            onClick={() =>
                              bulkEditHelper(
                                "switchSigns",
                                transactionIds
                              ).then(() => {
                                if (setSelectedRowsIds) {
                                  setSelectedRowsIds({});
                                }
                              })
                            }
                            className="mx-1"
                          >
                            <FontAwesomeIcon icon="random" className="mr-1" />
                            Switch credits/debits
                          </Btn>,
                        )}
                        {wrapDisabled(
                          "switch-included",
                          <Btn
                            variant="tertiary"
                            size="sm"
                            disabled={!hasSelection}
                            onClick={() =>
                              bulkEditHelper(
                                "switchIncludedExcluded",
                                transactionIds
                              ).then(() => {
                                if (setSelectedRowsIds) {
                                  setSelectedRowsIds({});
                                }
                              })
                            }
                            className="mx-1"
                          >
                            <FontAwesomeIcon icon="random" className="mr-1" />
                            Switch included/excluded
                          </Btn>,
                        )}
                        {wrapDisabled(
                          "bulk-edit",
                          <Btn
                            variant="tertiary"
                            size="sm"
                            disabled={!hasSelection}
                            onClick={() => {
                              setBulkEditFieldKey("");
                              setBulkEditValue("");
                              setShowBulkEditModal(true);
                            }}
                            className="mx-1"
                          >
                            <FontAwesomeIcon icon="edit" className="mr-1" />
                            Bulk edit
                          </Btn>,
                        )}
                      </div>
                    </div>
                    <Modal
                      show={showBulkEditModal}
                      onHide={() => setShowBulkEditModal(false)}
                    >
                      <Modal.Header
                        closeButton
                        placeholder=""
                        onPointerEnterCapture={() => {}}
                        onPointerLeaveCapture={() => {}}
                      >
                        <Modal.Title>Bulk edit field</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <p className="text-muted">
                          Set one field to the same value across{" "}
                          <strong>
                            {affectedCount}{" "}
                            {affectedCount === 1
                              ? "transaction"
                              : "transactions"}
                          </strong>
                          .
                        </p>
                        <Form.Group>
                          <Form.Label>Field</Form.Label>
                          <Form.Control
                            as="select"
                            value={bulkEditFieldKey}
                            onChange={(e) => {
                              setBulkEditFieldKey(e.target.value);
                              setBulkEditValue("");
                            }}
                          >
                            <option value="">Select a field…</option>
                            {BULK_EDIT_FIELDS.map((f) => (
                              <option key={f.key} value={f.key}>
                                {f.label}
                              </option>
                            ))}
                          </Form.Control>
                        </Form.Group>
                        {bulkEditFieldDef && (
                          <Form.Group>
                            <Form.Label>New value</Form.Label>
                            <Form.Control
                              type={
                                bulkEditFieldDef.type === "number"
                                  ? "number"
                                  : "text"
                              }
                              placeholder={
                                bulkEditFieldDef.type === "date"
                                  ? "YYYY-MM-DD"
                                  : ""
                              }
                              value={bulkEditValue}
                              isInvalid={
                                bulkEditValue.length > 0 &&
                                !!bulkEditValidationError
                              }
                              onChange={(e) =>
                                setBulkEditValue(e.target.value)
                              }
                            />
                            {bulkEditValue.length > 0 &&
                              bulkEditValidationError && (
                                <Form.Control.Feedback
                                  type="invalid"
                                  style={{ display: "block" }}
                                >
                                  {bulkEditValidationError}
                                </Form.Control.Feedback>
                              )}
                          </Form.Group>
                        )}
                      </Modal.Body>
                      <Modal.Footer>
                        <Btn
                          variant="tertiary"
                          onClick={() => setShowBulkEditModal(false)}
                        >
                          Cancel
                        </Btn>
                        <Btn
                          variant="primary"
                          disabled={!!bulkEditValidationError}
                          onClick={applyBulkEdit}
                        >
                          Apply
                        </Btn>
                      </Modal.Footer>
                    </Modal>
                    </>
                  );
                }}
                hasExport={false}
                height={"75vh"}
                width={"100%"}
                defaultColDef={defaultColDef}
                colResizeDefault="shift"
                singleClickEdit
                rowModelType={"infinite"}
                onColumnResized={onColumnResized}
                cacheBlockSize={paginationPageSize}
                cacheOverflowSize={2}
                maxConcurrentDatasourceRequests={1}
                infiniteInitialRowCount={1}
                maxBlocksInCache={2}
                pagination={true}
                paginationPageSize={paginationPageSize}
              />
            </div>
          </Split>
        </Col>
      </Row>
    </div>
  );
};
export default NewTransactionManager;
